import { MERCHANT_OPERATIONS } from "@price-rescue/api-contracts";
import type {
  ProductMappingChecksInput,
  ProductMappingChecksPreview,
  ProductMappingChecksResult,
  CatalogRepairJobProgressDto,
} from "@price-rescue/api-contracts";
import type { MerchantApiClient } from "../../types.js";
import { freezeProductBulkSelection } from "./product-bulk-selection.js";

// The existing merchant job-status operation exposes the same progress shape for all jobs.
export type MappingCheckJobProgress = CatalogRepairJobProgressDto;
export interface ProductMappingChecksService {
  preview(input: ProductMappingChecksInput): Promise<ProductMappingChecksPreview>;
  execute(
    input: ProductMappingChecksInput,
    idempotencyKey: string,
  ): Promise<ProductMappingChecksResult>;
  getJob(jobId: string): Promise<MappingCheckJobProgress>;
}
export function createProductMappingChecksService(
  client: Pick<MerchantApiClient, "operation">,
): ProductMappingChecksService {
  return {
    async preview(input) {
      const response = await client.operation<{ data: ProductMappingChecksPreview }>(
        MERCHANT_OPERATIONS.previewProductMappingChecks,
        {
          body: { productIds: freezeProductBulkSelection(input.productIds.map((id) => id.trim())) },
        },
      );
      return response.data;
    },
    async execute(input, idempotencyKey) {
      const response = await client.operation<{ data: ProductMappingChecksResult }>(
        MERCHANT_OPERATIONS.queueProductMappingChecks,
        {
          body: { productIds: freezeProductBulkSelection(input.productIds.map((id) => id.trim())) },
          request: { idempotencyKey },
        },
      );
      return response.data;
    },
    async getJob(jobId) {
      const response = await client.operation<{ data: MappingCheckJobProgress }>(
        MERCHANT_OPERATIONS.getMerchantJobStatus,
        { pathParams: { jobId } },
      );
      return response.data;
    },
  };
}
